import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { DATA_UPDATE_GROUPS } from '../../../../../shared/dpRequests';
import { formatFieldValue } from '../../dpRequests.formatters';
import type { ChangeReviewProps } from './changeReview.types';

export function ChangeReview({ changes, emptyText = 'Nenhuma alteração.' }: ChangeReviewProps) {
    if (changes.length === 0) {
        return <p className="text-sm text-raro-gray-500">{emptyText}</p>;
    }

    const groupOrder = new Map<string, number>(DATA_UPDATE_GROUPS.map((group, index) => [group.id, index]));
    const sorted = changes.slice().sort((a, b) => (groupOrder.get(a.group) ?? 0) - (groupOrder.get(b.group) ?? 0));

    return (
        <ul className="divide-y divide-raro-gray-100 overflow-hidden rounded-xl border border-raro-gray-200 bg-white">
            {sorted.map(change => (
                <li key={change.field} className="grid gap-2 px-4 py-3 sm:grid-cols-[minmax(0,1fr)_auto_minmax(0,1.4fr)] sm:items-start sm:gap-3">
                    <p className="text-sm font-semibold text-raro-gray-800">{change.label}</p>
                    <div className="hidden pt-0.5 text-raro-gray-300 sm:block">
                        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
                    </div>
                    <div className="grid gap-1 text-sm">
                        <ValueLine label="Antes" values={formatFieldValue(change.field, change.before)} muted />
                        <ValueLine label="Depois" values={formatFieldValue(change.field, change.after)} />
                    </div>
                </li>
            ))}
        </ul>
    );
}

function ValueLine({ label, values, muted = false }: { label: string; values: string[]; muted?: boolean }) {
    return (
        <div className="flex gap-2">
            <span className="w-14 shrink-0 text-xs font-medium uppercase tracking-wide text-raro-gray-400">{label}</span>
            <div className={muted ? 'text-raro-gray-500 line-through decoration-raro-gray-300' : 'font-medium text-raro-gray-900'}>
                {values.map((value, index) => (
                    <p key={index} className="break-words">{value}</p>
                ))}
            </div>
        </div>
    );
}
